import { render, staticRenderFns } from "./StatisticsUserStatus.vue?vue&type=template&id=2aaab9a7&"
import script from "./StatisticsUserStatus.vue?vue&type=script&lang=js&"
export * from "./StatisticsUserStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports